import { render, staticRenderFns } from "./shellStudent.vue?vue&type=template&id=56a8155a&comments=true&"
import script from "./shellStudent.vue?vue&type=script&lang=js&"
export * from "./shellStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/syncScreen/shellStudent.vue"
export default component.exports